<template lang="pug">
.media-admin-filter
  .field
    label Sichtbarkeit:
    select(v-model="visibility")
      option(value="1") Gesperrt
      option(value="2") Privat
      option(value="3") Freunde
      option(value="4") Öffentlich

  .field
    checker(caption="Medien ohne Tags", :checked="noTags", @update:checked="val => noTags = val")
    checker(caption="mit Tags", :checked="useTags", @update:checked="val => useTags = val")
    media-tags(v-show="useTags", mode="filter", @change="updateTags")

  .field
    label Quelle (Dateiname):
    input(type="text", v-model="search", placeholder="source_path enthält ...")

  .field
    label Person
    input(type="text", v-model="person", placeholder="name enthält ...")
    select(v-model="face",id="faceid",name="faceid")
      option(v-for="f in groups", :value="f.id") {{f.name}}

  .field
    label IDs:
    input(type="text", v-model="idlist", placeholder="Liste der IDs")

  .field(style="display: flex; flex-flow: row")
    label Zeitraum:
    input(type="date", v-model="dateFrom")
    input(type="date", v-model="dateTo")

  .field
    checker(caption="mit GPS",:checked="useGPS", @update:checked="val => useGPS = val")
    MediaMapFilter(v-show="useGPS", @update-map-bounds="handleMapBoundsUpdate")

  .actions
    button3d(type="submit")
      icon.small(name="play", @click="update")
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import Button3d from "./Button3d.vue";
import Checker from "@/components/Checker.vue";
import Icon from "./Icon.vue";
import MediaTags from "./MediaTags.vue";
import MediaMapFilter from "./MediaMapFilter.vue";

export default {
  name: "MediaAdminFilter",
  components: { Icon, Button3d, Checker, MediaTags, MediaMapFilter },
  data() {
    return {
      tagStates: {},
      excludeTags: false,
      visibility: 0,
      search: "",
      person: "",
      face: null,
      idlist: "",
      type: "",
      dateFrom: "",
      dateTo: "",
      noTags: false,
      useTags: false,
      useGPS: false,
      mapCenter: { lat: 48.1351, lng: 11.582 }, // München als Beispiel
      mapBounds: {
        north: 48.3,
        south: 48.0,
        east: 11.7,
        west: 11.4,
      },
    };
  },
  watch: {
    filter: {
      deep: true,
      immediate: true,
      handler(val) {
        this.localFilter = Object.assign({}, val);
      },
    },
  },
  async mounted() {
    // await this.getTags();
    await this.loadGroups();
  },
  computed: {
    ...mapGetters({
      // tags: "media/tags",
      groups: "faces/groups",
    }),
  },
  methods: {
    ...mapActions({
      // getTags: "media/tags",
      loadGroups: "faces/loadGroups",
      updateFilter: "media/updateFilter",
    }),
    handleMapBoundsUpdate(mapBounds) {
      // Wenn die Kartengrenzen geändert werden, setze sie hier
      this.mapBounds = mapBounds;
    },
    updateTags(states) {
      console.log('states',states);
      this.tagStates = states;
    },
    update() {
      const ts = Object.keys(this.tagStates);
      const includeTags = ts.filter(id => this.tagStates[id] == 1);
      const excludeTags = ts.filter(id => this.tagStates[id] == 2);

      console.log('UPDATE:',this.tagStates, ts, includeTags, excludeTags)
      const filter = {
        isAdmin: true,
        visibility: parseInt(this.visibility),
        includeTags,
        excludeTags,
        type: this.type,
        dateFrom: this.dateFrom || null,
        dateTo: this.dateTo || null,
        noTags: this.noTags,
        useTags: this.useTags,
        useGPS: this.useGPS,
        bounds: this.mapBounds,
        search: this.search,
        person: this.person,
        face: this.face,
        idlist: this.idlist,
      };
      console.log("update filter:", filter);
      this.updateFilter(filter);
      this.$emit("runFilter");
    },
  },
};
</script>

<style lang="less" scoped>
.media-admin-filter {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  .field {
    margin-bottom: 1em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .actions {
    align-self: stretch;
    justify-content: flex-end;
    display:flex;
    margin-top: 1em;
    align-items: center;
  }
}
</style>
